<template>
    <ul class="online_service noprint" v-if="siteInfo.enableSidebar ==1">
        <template v-if="settings.enabled == 1">
            <li :class="`li_second ${settings.bgColor}`" v-if="qqService">
                <i class="iconfont icon-yushua-QQ1"></i>
                <span>QQ客服</span>
                <div>
                    <template v-for="(qq, index) in qqService">
                        <div class="clearfix item-wrapper" :class="`${settings.bgColor}`" :key="index">
                            <a :href="'tencent://message/?uin='+qq[1]" target="blank">
                                <p>{{qq[0]&&qq[0]}}</p>
                            </a>
                        </div>
                    </template>
                </div>
            </li>
            <li :class="`li_second  ${settings.bgColor}`" v-if="settings.contactPerson">
                <i class="el-icon-headset"></i>
                <span>电话客服</span>
                <div>
                    <div class="clearfix phone-custom-service">
                        <span>工作时间：{{settings.contactPeriod}}</span>
                        <div class="phone-custom-item mt10" v-for="phone in contactPhoneService" :key="phone">{{phone[0]&&phone[0]}}:{{phone[1]&&phone[1]}}</div>
                    </div>
                </div>
            </li>
            <li :class="`li_second mobile_spaceil  ${settings.bgColor}`" v-if="settings.weixinName&&settings.weixinQrCode">
                <i class="iconfont icon-yushuys-share-weixin"></i>
                <span>微信客服</span>
                <div>
                    <div class="clearfix">
                        <yushu-image :url="settings.weixinQrCode" size="80x80"></yushu-image>
                        <!-- <img :src="settings.weixinQrCode" height="80" width="80" /> -->
                        <p>{{settings.weixinName}}</p>
                    </div>
                </div>
            </li>
            <li :class="`li_second mobile_spaceil  ${settings.bgColor}`" v-if="settings.email">
                <i class="el-icon-message"></i>
                <span>邮件支持</span>
                <div>
                    <div class="clearfix" style="display:flex">
                        <p>邮箱地址：{{settings.email}}</p>
                    </div>
                </div>
            </li>
        </template>
        <!-- <template v-if="Utils.getPropertyValueInArray($store.getters.siteInfo.params, 'key', 'enabledAPPQrCode', 'value') == Constants.Yes">
            <li :class="`li_second ${settings.bgColor}` " class="li_qrcode">
                <i class="el-icon-aim"></i>
                <span>APP下载</span>
                <i class="el-icon-aim"></i>
                <span>APP下载</span>
                <div style="width:auto;">
                    <div class="clearfix" style="display:flex;width:auto">
                        <div style="display:inline-block; width:120px;height:120px;" v-for="app in apps" :key="app.url">
                            <img :src="app.qrImg" height="120" width="120" />
                            <span v-if="app.name && app.name.length > 0">{{app.name}}</span>
                        </div>
                    </div>
                </div>
            </li>
        </template> -->
        <li :class="`li_three ${settings.bgColor}`" @click="scrollTops">
            <i class="el-icon-arrow-up"></i>
            <span>返回顶部</span>
        </li>
    </ul>
</template>
<script>
import { mapGetters } from "vuex";
import { Encoder, ErrorCorrectionLevel } from "@nuintun/qrcode";
import SiteAPI from "@/web-framework/api/site.js";
export default {
    name: "YushuSidebar",
    data: function () {
        return {
            scrollTop: 0,
            show: false,
            settings: {},
            apps: [],
            qrcode: undefined
        };
    },
    computed: {
        qqService() {
            if (this.settings && this.settings.qq) {
                let tempArr = [];
                let qqArr = this.settings.qq.split(",");
                qqArr.forEach((ele, ind) => {
                    tempArr[ind] = ele.split("|");
                });
                return tempArr;
            } else {
                return false;
            }
        },
        contactPhoneService() {
            if (this.settings && this.settings.contactPerson) {
                let tempArr = [];
                let qqArr = this.settings.contactPerson.split(",");
                qqArr.forEach((ele, ind) => {
                    tempArr[ind] = ele.split("|");
                });
                return tempArr;
            } else {
                return false;
            }
        },
        ...mapGetters({
            siteInfo: "siteInfo"
        })
    },
    created: function () {
        this.initCustomServiceInfo();
    },
    mounted: function () {
        this.initScroll();
    },
    methods: {
        createQrcode(url) {
            const qrcode = new Encoder();
            qrcode.setEncodingHint(true);
            qrcode.setErrorCorrectionLevel(ErrorCorrectionLevel.H);
            qrcode.write(url);
            qrcode.make();
            return qrcode.toDataURL();
        },
        initScroll: function () {
            // 监听页面滚动事件
            window.onscroll = () => {
                this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            };
        },
        scrollTops: function () {
            this.Utils.scrollTops(window, this.scrollTop, true); // 回到顶部
        },
        initCustomServiceInfo() {
            let domainName = this.Utils.getRequestParam(this, 'domain');
            if (domainName) {
                SiteAPI.getSiteCustomServiceByDomain(domainName).then(result => {
                    this.loading = true;
                    Request.validateResult(result, () => {
                        let data = result.data || {};
                        if (data && data.id) {
                            Vue.set(this, 'settings', result.data || {});
                        }
                    });
                }).catch(error => {
                    this.loading = false;
                    Request.validateCatchError(error);
                });
            } else {
                SiteAPI.getCurrentSiteCustomService().then(result => {
                    this.loading = true;
                    Request.validateResult(result, () => {
                        let data = result.data || {};
                        if (data && data.id) {
                            Vue.set(this, 'settings', result.data || {});
                        }
                    });
                }).catch(error => {
                    this.loading = false;
                    Request.validateCatchError(error);
                });
            }
        }
    }
};
</script>
<style lang="less">
.online_service {
    position: fixed;
    bottom: 120px;
    right: 0;
    z-index: 2000;

    .li_qrcode {
        & > div {
            display: none;
        }

        &:hover > div {
            display: inline-block;
            width: auto;
        }
    }

    li {
        margin-bottom: 5px;
        width: 60px;
        height: 60px;
        border-radius: 2px;
        border: 1px solid rgba(209, 209, 209, 1);
        text-align: center;
        background: #fff;
        position: relative;
        cursor: pointer;
        transition: all 0.2s;
        border-radius: 4px;
        .item-wrapper {
            &:hover {
                background-color: #37b97d;
                border-color: #37b97d;
                a {
                    p {
                        color: #ffffff;
                    }
                }
            }
        }

        // 电话客服
        .phone-custom-service {
            .phone-custom-item {
                color: #2a2a2a;
                font-size: 13px;
                text-align: left;
            }
        }
        a {
            height: 100%;
            width: 100%;

            & > i,
            & > span {
                display: inline-block;
                width: 100%;
                transition: all 0.2s;
            }

            & > i {
                margin-top: 11px;
                font-size: 24px;
                color: #666;
                line-height: 1;
            }

            & > span {
                font-size: 12px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 12px;
            }
        }

        & > i,
        & > span {
            display: inline-block;
            width: 100%;
            transition: all 0.2s;
        }

        & > i {
            margin-top: 11px;
            font-size: 24px;
            color: #666;
            line-height: 1;
        }

        & > span {
            font-size: 12px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 12px;
        }

        &:last-child {
            margin-bottom: 0;
        }

        &:hover {
            background: rgba(0, 158, 255, 1);
            border: 1px solid rgba(0, 158, 255, 1);
            color: #fff;

            i,
            span {
                color: #fff;
            }
        }
    }

    li {
        &.li_first {
        }

        &.li_second {
            & > div {
                position: absolute;
                top: 0;
                right: 65px;
                width: 0;
                transition: all 0.3s;
                overflow: hidden;

                & > div {
                    position: relative;
                    background: rgba(255, 255, 255, 1);
                    border: 0.4px solid rgba(209, 209, 209, 1);
                    padding: 4px 4px 7px;
                    width: 142px;

                    &:before {
                        position: absolute;
                        top: 12px;
                        right: -5px;
                        content: '';
                        width: 8px;
                        height: 8px;
                        background: #fff;
                        border-top: 0.4px solid #d1d1d1;
                        border-right: 0.4px solid #d1d1d1;
                        transform: rotate(45deg);
                    }

                    p {
                        font-size: 12px;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 12px;
                    }
                }
            }

            &.li_second > div > div {
                padding: 10px 8px;

                p {
                    font-size: 14px;
                    line-height: 20px;
                }

                span {
                    color: #999;
                    font-size: 12px;
                }
            }

            &:hover {
                & > div {
                    width: 150px;
                }

                &:after {
                    position: absolute;
                    top: 0;
                    right: 59px;
                    content: '';
                    width: 15px;
                    height: 59px;
                }
            }

            &.mobile_spaceil {
                position: relative;

                & > div > div {
                    width: 200px;
                }

                & > span {
                    position: absolute;
                    bottom: 7px;
                    left: 50%;
                    width: 62px;
                    transform: translateX(-50%);
                }

                &:hover > div {
                    width: 210px;
                }
            }
        }
    }

    .default {
        &:hover {
            background-color: #37b97d !important;
            border-color: #37b97d !important;
        }
    }

    .warning {
        &:hover {
            background-color: #e67e22 !important;
            border-color: #e67e22 !important;
        }
    }

    .danger {
        &:hover {
            background-color: #e74c3c !important;
            border-color: #e74c3c !important;
        }
    }
}
</style>